module.exports = __webpack_public_path__ + "static/media/chf.53d6eb21.svg";